var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13.25C9.9518 13.25 12.75 10.4518 12.75 7C12.75 3.54822 9.9518 0.75 6.5 0.75C3.04822 0.75 0.25 3.54822 0.25 7C0.25 10.4518 3.04822 13.25 6.5 13.25ZM9.39617 5.98993C9.70125 5.68483 9.70125 5.19017 9.39617 4.88507C9.09109 4.57998 8.59641 4.57998 8.29133 4.88507L5.71875 7.45766L4.70868 6.44757C4.40358 6.14248 3.90892 6.14248 3.60382 6.44757C3.29873 6.75267 3.29873 7.24734 3.60382 7.55242L5.16632 9.11492C5.47142 9.42 5.96608 9.42 6.27118 9.11492L9.39617 5.98993Z",
    fill: "#0CD100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/checkRound.d77293b68be45bfd1fb55182d5fc9e9a.svg";
export { ForwardRef as ReactComponent };